module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-brands-400.woff2?a0f6b35c2b55babc93cb9b15791a1d4c";